import React from 'react';
import Pill, { PillDot } from '../Pill';
import { CARRIER_STATUS_TONES } from '../constants';

const StatusCell = ({ row }) => {
    const { status } = row.original;
    if (!status) return <span className="text-sm text-muted">-</span>;

    return (
        <Pill tone={CARRIER_STATUS_TONES[status]}>
            <PillDot />
            {status}
        </Pill>
    );
};

export default StatusCell;
